/**
 * 商品企画マスタ画面　次回案内自動設定VOクラス
 */
export class KYMW1300UpdateNextGuideAutoModel {

  public orderCode: string = null;                                              // 受注コード
  public mediumType: string = null;                                             // 媒体区分
  public pCodeList: Array<string> = new Array<string>();                        // Ｐコードリスト

}
